<div *ngIf="loading else main">
  <mat-spinner diameter="150" strokeWidth="10" mode="indeterminate"></mat-spinner>
</div>

<ng-template #main>
  <div class="d-flex flex-column confirmation-container">
    <div class="upper-row" *ngIf="data.simpleClose">
      <button (click)="close()">
        <mat-icon aria-hidden="false">close</mat-icon>
      </button>
    </div>
    <h1 mat-dialog-title>{{data.title}}</h1>
    <div mat-dialog-content>
      {{data.message}}
    </div>
    <div class="button-row">
      <button [mat-dialog-close]="false" class="button-blueGDPR button-grey">
        {{ data.dismiss }}
      </button>
      <button class="button-blueGDPR" (click)="closeWithLoading()">
        {{ data.confirm }}
      </button>
    </div>
  </div>
</ng-template>
